import React, { useRef, useState } from "react";
import closeIcon from "../assets/icon simple close.png";
import SubmitJSON from "submitjson";

interface EnquiryModalProps {
  open: boolean;
  onClose: () => void;
}

/* ----------------------------------------
   0.  Configure your SubmitJSON instance
       – keep keys in .env
   ---------------------------------------- */
const sj = new SubmitJSON({
  apiKey: 'sjk_c4380b32694d41f8a3762dd1c3461a87',          // sjk_xxxxxx  (omit if "API key not required")
  endpoint: 'ZeF9F3Spb',       // slug from the dashboard, e.g. "abc123"
});

const countryCodes = [
  { code: "+91", label: "India" },
  { code: "+1", label: "USA" },
  { code: "+44", label: "UK" },
];

const EnquireMobile: React.FC<EnquiryModalProps> = ({ open, onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);

  /* ----------------------------------------
     1. Controlled inputs (keeps code concise)
     ---------------------------------------- */
  const [form, setForm] = useState({
    name: "",
    email: "",
    countryCode: "+91",
    phone: "",
    message: "",
    offers: false,
  });
  const [sending, setSending] = useState(false);

  // Close on backdrop click
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === modalRef.current) {
      onClose();
    }
  };

  /* ----------------------------------------
     2. Submit handler → SubmitJSON
     ---------------------------------------- */
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSending(true);

    try {
      await sj.submit({
        name: form.name,
        email: form.email,
        phone: `${form.countryCode} ${form.phone}`,
        message: form.message,
        wantsOffers: form.offers,
      });
      alert("Thanks! We'll be in touch shortly.");
      setForm({ name: "", email: "", countryCode: "+91", phone: "", message: "", offers: false });
      onClose();                                    // close the modal if you like
    } catch (err: any) {
      console.error(err);
      alert("Sorry — something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  if (!open) return null;

  return (
    <div
      ref={modalRef}
      onClick={handleBackdropClick} 
      className="fixed inset-0 z-[100] flex  bg-black/30 transition-all duration-300 "
      aria-modal="true"
      role="dialog"
    >
      <div className="relative w-full max-w-full !h-[740px] bg-[#f5f7fa]  p-4 flex flex-col transition-transform duration-300 translate-x-0">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-6 p-2 focus:outline-none"
          aria-label="Close"
        >
          <img src={closeIcon} alt="Close" className="w-6 h-6" />
        </button>
        {/* Title */}
        <h2 className="font-utility w-[372px] text-[24px] font-medium text-[#011621] mb-6 mt-[46px] leading-tight  ">
          Complete The Form Below And<br />Our Representatives Will<br />Contact You Shortly!
        </h2>
        {/* Form */}
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 flex-1 w-[372px]   ">
          <div>
            <label className="font-inter  block text-[16px] font-normal text-[#033652] mb-1">Full Name</label>
            <input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Enter your name"
              className="w-full px-4 py-2    focus:outline-none focus:ring-2 focus:ring-[#1e5d66] bg-white"
              required
            />
          </div>
          <div>
            <label className="block font-inter   text-[16px] font-normal text-[#033652] mb-1">Email Address</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="Enter your email address"
              className="w-full px-4 py-2   focus:outline-none focus:ring-2 focus:ring-[#1e5d66] bg-white"
              required
            />
          </div>
          <div>
            <label className="font-inter  block text-[16px] font-normal text-[#033652] mb-1">Phone Number</label>
            <div className="flex">
              <select 
                value={form.countryCode}
                onChange={(e) => setForm({ ...form, countryCode: e.target.value })}
                className="  px-2 py-2 bg-white text-[#4F7286] focus:outline-none ">
                {countryCodes.map((c) => (
                  <option key={c.code} value={c.code}>{c.code}</option>
                ))}
              </select>
              <input
                type="tel"
                value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                placeholder="Phone number"
                className="w-full px-4 py-2  focus:outline-none focus:ring-2 focus:ring-[#1e5d66] bg-white"
                required
              />
            </div>
          </div>
          <div>
            <label className="font-inter  block text-[16px] font-normal text-[#033652] mb-1">Message</label>
            <textarea
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Please type your message here"
              className="w-full px-4 py-2  focus:outline-none focus:ring-2 focus:ring-[#1e5d66] bg-white min-h-[80px]"
              required
            />
          </div>
          <div className="flex items-center mt-2">
            <input 
              type="checkbox" 
              id="offers" 
              checked={form.offers}
              onChange={(e) => setForm({ ...form, offers: e.target.checked })}
              className="mr-2" 
            />
            <label htmlFor="offers" className="text-[14px] text-[#011621]">I wish to receive offers & promotions</label>
          </div>
          <button
            type="submit"
            disabled={sending}
            className="font-inter w-full bg-[#07394a] text-white  py-2 text-[16px] font-medium mt-4 hover:bg-[#1e5d66] transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {sending ? "Sending…" : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EnquireMobile; 